export default {
    subtitle: '各書類タイプへ変換する際の設定',
    title: '変換',
};
